import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getformAPi,deleteformApi } from "../../../ApiUrl";
export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,
};
// get form
export const getform = createAsyncThunk('getform/form', async () => {
    try {
        const response = await axios.get(`${getformAPi}?limit=`, { headers });
        return response.data; 
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete form
export const deleteforms = createAsyncThunk('deleteforms/form', async (formid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${deleteformApi}/${formid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'formid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const formSlice = createSlice({
    name: 'form',
    initialState: {
        forms: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //getforms
            .addCase(getform.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getform.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.forms = action.payload;
            })
            .addCase(getform.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete forms
            .addCase(deleteforms.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteforms.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.forms.data = state.forms.data.filter(forms => forms.formid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deleteforms.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default formSlice.reducer;
